import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Checkbox from "@mui/material/Checkbox";
import {changeUserInfo} from "../../../actions/actionFunctions";

const LookRegisterCheckboxes = (props) => {

  const {userInfo, changeUserInfo} = props;

  const termsButtonClick = (event) => {
    changeUserInfo({
      agreedToTerms: event.target.checked
    });
  }

  const subscribeButtonClick = (event) => {
    changeUserInfo({
      subscribeToNewsletter: event.target.checked
    });
  }

  return (
    <Fragment>
      <p className="look-checkbox">
        <Checkbox
          checked={userInfo.agreedToTerms}
          onChange={termsButtonClick}
        />
        <span className="look-secondary">
          <FormattedMessage id="look.register.termsText"/> <span className="look-link" onClick={termsButtonClick}>
            <FormattedMessage id="look.register.termsLink"/>
          </span>
        </span>
      </p>
      <p className="look-checkbox">
        <Checkbox
          checked={userInfo.subscribeToNewsletter}
          onChange={subscribeButtonClick}
        />
        <span className="look-secondary">
          <FormattedMessage id="look.register.subscribe"/>
        </span>
      </p>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {userInfo} = store.userState;
  return {
    userInfo,
  };
};

const mapDispatchToProps = {
  changeUserInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(LookRegisterCheckboxes)
